// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_CancelInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/cancel/{id}
 *
 * The order id arrives as a URL path segment. The cancellation reason is
 * mandatory for every group — it is persisted on the order for audit.
 */
import { registerContract } from './validate'

export interface Orders_CancelInput {
reason: string
}

registerContract('Orders_CancelInput', {
  reason: { type: 'string',  required: true },
})
